// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__3VVBl","header":"Portfolio_header__rqBWH","divder":"Portfolio_divder__ptS2U"};